<template>
  <div class="map-render">
    <!-- 地图容器 地图将在这里渲染 -->
    <div class="map" :id="mapid"></div>
    <!-- 鼠标经过地图 右下角显示经纬度 -->

    <!-- 地图左侧工具栏 -->
    <div class="left-nav">
      <div class="nav-item" :class="{ active: activeLeftNav == '图层管理' }" title="图层管理" @click="toggleLayerManage()">
        <span class="fa fa-clone"> </span>
      </div>
      <div class="nav-item" :class="{ active: activeLeftNav == '数据筛选' }" title="数据筛选" @click="toggleAttributeSearch()">
        <span class="fa fa-filter"> </span>
      </div>
      <div class="nav-item" :class="{ active: activeLeftNav == '按乡镇查询' }" title="按乡镇查询" @click="toggleRegionSearch()">
        <span class="fa fa-map"> </span>
      </div>
      <div class="nav-item" :class="{ active: activeLeftNav == '定位周边' }" title="定位周边" @click="toggleGeoSearch()">
        <span class="fa fa-map-marker"> </span>
      </div>
      <div class="nav-item" :class="{ active: activeLeftNav == '设置' }" title="设置" @click="toggleMapToolBar()">
        <span class="fa fa-wrench"> </span>
      </div>
    </div>

    <!-- 图层管理 面板 -->
    <LayerManage :mapid="mapid" v-show="showLayerManage && activeLeftNav == '图层管理'" class="animate__animated"
      :closeAllPanel="closeAllPanel" v-bind:class="{
        animate__slideInLeft: showLayerManage,
        animate__slideOutLeft: !showLayerManage,
      }"></LayerManage>

    <!-- 数据筛选 面板 -->
    <AttributeSearch v-show="showAttributeSearch && activeLeftNav == '数据筛选'" :closeAllPanel="closeAllPanel">
    </AttributeSearch>

    <!-- 按乡镇查询 面板 -->
    <RegionSearch v-show="showRegionSearch && activeLeftNav == '按乡镇查询'" :closeAllPanel="closeAllPanel"></RegionSearch>

    <!-- 定位周边 面板 -->
    <GeolocationSearch v-show="showGeolocationSearch && activeLeftNav == '定位周边'" :closeAllPanel="closeAllPanel">
    </GeolocationSearch>

    <!-- 工具栏 -->
    <MapToolBar ref="mapToolBar" v-show="showMapToolBar && activeLeftNav == '设置'"
      @toggleNewFeaturePanel="toggleNewFeaturePanel"></MapToolBar>

    <!-- 新增点 面板 -->
    <NewPoint v-show="showNewFeature && newFeatureType == 'Point'" @toggleNewFeaturePanel="toggleNewFeaturePanel">
    </NewPoint>

    <!-- 新增线  面板-->
    <NewLine v-show="showNewFeature && newFeatureType == 'LineString'" @toggleNewFeaturePanel="toggleNewFeaturePanel">
    </NewLine>

    <!-- 新增面  面板-->
    <NewPolygon v-show="showNewFeature && newFeatureType == 'Polygon'" @toggleNewFeaturePanel="toggleNewFeaturePanel">
    </NewPolygon>

    <!-- 点击地图弹出文化点信息  面板-->
    <SearchResultDialog ref="searchResultDialog" style="left: 574px; top: 36px" v-show="searchResultDialogType == 1"
      :activeFeature="selectedFeature"></SearchResultDialog>

    <!-- 图例 -->
    <Legend v-show="showLegendPanel"></Legend>

    <UpLoadShp v-show="showMapToolBar && activeLeftNav == '设置'"></UpLoadShp>
  </div>
</template>
<script>
import LayerManage from "./LayerManage.vue";
import MapToolBar from "./MapToolBar.vue";
import NewPoint from "./NewFeature/NewPoint.vue";
import NewLine from "./NewFeature/NewLine.vue";
import NewPolygon from "./NewFeature/NewPolygon.vue";
import AttributeSearch from "./Search/AttributeSearch.vue";
import RegionSearch from "./Search/RegionSearch.vue";
import GeolocationSearch from "./Search/GeolocationSearch.vue";
import SearchResultDialog from "./Search/SearchResultDialog.vue";
import UpLoadShp from "./UpLoadShp.vue";
import { debuglog } from "util";
import { match } from "minimatch";
import { setTimeout } from "timers";
import Legend from "./Legend.vue";
export default {
  name: "MapRender",
  props: {
    themlayers: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      activeLeftNav: "图层管理",
      mapMain: null,
      mapid: "ol-map-main-id", // 不要改
      coorid: "ol-map-main-coor-id", // 不要改
      showLayerManage: true,
      showNewFeature: false,
      isMapPolySearching: false,
      showMapToolBar: false,
      showAttributeSearch: false,
      showRegionSearch: false,
      showGeolocationSearch: false,
      mapClickEventEmiterInited: false,
      selectedFeature: {},
    };
  },
  watch: {},
  computed: {
    newFeatureType() {
      return this.$store.state.newFeatureType;
    },
    showLegendPanel() {
      return this.$store.state.showLegendPanel;
    },
    searchResultDialogType() {
      return this.$store.state.searchResultDialogType;
    },
  },
  components: {
    LayerManage,
    MapToolBar,
    NewPoint,
    NewLine,
    NewPolygon,
    AttributeSearch,
    RegionSearch,
    GeolocationSearch,
    SearchResultDialog,
    Legend,
    UpLoadShp,
  },
  methods: {
    init() {
      //在这里初始化一个地图
      let viewConfig = {
        center: [115.7, 40], // 地图默认的中心点
        zoom: 11, // 地图默认缩放级别 1 - 18
        maxZoom: 18, // 地图默认的中心点 1 - 18
        minZoom: 2, // 地图默认的中心点 1 - 18
      };
      this.mapMain = this.xxMap.init(viewConfig);
      setTimeout(() => {
        this.$refs.mapToolBar.map = this.mapMain;
      }, 200);
      this.mapFeatureClickLister();
    },
    closeAllPanel() {
      this.showLayerManage = false;
      this.showAttributeSearch = false;
      this.showRegionSearch = false;
      this.showGeolocationSearch = false;
      this.activeLeftNav = null;
      this.xxMap.toggleGeoSearch(false);
    },

    toggleLayerManage() {
      // 打开或关闭图层面板
      this.showLayerManage = !this.showLayerManage;
      this.showLayerManage
        ? (this.activeLeftNav = "图层管理")
        : (this.activeLeftNav = null);
      this.xxMap.toggleGeoSearch(false);
    },
    toggleMapToolBar() {
      // 打开或关闭工具栏
      this.showMapToolBar = !this.showMapToolBar;
      this.showMapToolBar
        ? (this.activeLeftNav = "设置")
        : (this.activeLeftNav = null);
      this.xxMap.toggleGeoSearch(false);
    },
    toggleAttributeSearch() {
      // 打开或关闭 数据筛选
      this.showAttributeSearch = !this.showAttributeSearch;
      this.showAttributeSearch
        ? (this.activeLeftNav = "数据筛选")
        : (this.activeLeftNav = null);
      this.xxMap.toggleGeoSearch(false);
      this.$store.commit("setSearchResultDialogType", 0);
    },
    toggleRegionSearch() {
      // 打开或关闭 数据筛选
      this.showRegionSearch = !this.showRegionSearch;
      this.showRegionSearch
        ? (this.activeLeftNav = "按乡镇查询")
        : (this.activeLeftNav = null);
      this.xxMap.toggleGeoSearch(false);
      this.$store.commit("setSearchResultDialogType", 0);
    },
    toggleGeoSearch() {
      // 打开或关闭 数据筛选
      this.showGeolocationSearch = !this.showGeolocationSearch;
      this.showGeolocationSearch
        ? (this.activeLeftNav = "定位周边")
        : (this.activeLeftNav = null);
      this.xxMap.toggleGeoSearch(true);
      this.$store.commit("setSearchResultDialogType", 0);
    },

    toggleNewFeaturePanel(data) {
      this.showNewFeature = data;
    },
    // 监听地图点击事件
    mapFeatureClickLister() {
      if (this.mapClickEventEmiterInited) {
        return;
      }
      let that = this;
      this.mapClickEventEmiterInited = true;
      this.xxMap.mapEventEmiter.$on("feature-selected", (feature) => {
        let properties = feature.getProperties();

        if (!("pk" in properties)) {
          return;
        }
        let feature_type = feature.getGeometry().getType();
        let ajax_url = "";
        if (feature_type == "Point") {
          ajax_url = "/api/gis_app/culture_point_geojson/"; //查询 点
        } else if (feature_type == "LineString") {
          ajax_url = "/api/gis_app/culture_line_geojson/"; // 查询 线
        } else {
          ajax_url = "/api/gis_app/culture_polygon_geojson/"; // 查询 面
        }
        this.$axios({
          url: ajax_url,
          method: "post",
          data: {
            gid: properties.pk, //当前选择的要素id
          },
        }).then((res) => {
          let { status } = res.data;
          if (status === 200) {
            let selectedFeature = res.data.data;
            if (/文物资源/.test(selectedFeature.type)) {
              that.getRelicDetail(selectedFeature);
            } else {
              that.getCultureDetail(selectedFeature);
            }
          } else {
            console.log("查询出错啦！");
          }
        });
      });
    }, // 获取文物资源详情
    getCultureDetail(selectedFeature) {
      // 获取文化点的图片
      let params = {
        sno: selectedFeature.resoure,//"040001"//
      };
      this.$axios({
        url: "/chinacul/home/aajax/getcspoint",
        method: "get",
        params: params,
      }).then((res) => {
        let { code } = res.data;
        if (code === 0) {
          selectedFeature.cover = res.data.data.cover;
          selectedFeature.imglist = res.data.data.imglist;
          selectedFeature.address = res.data.data.address;
          selectedFeature.caidstr = res.data.data.caidstr;
          selectedFeature.longitude = res.data.data.longitude;
          selectedFeature.latitude = res.data.data.latitude;
          selectedFeature.altitude = res.data.data.altitude;
          selectedFeature.ccidstr = res.data.data.ccidstr;
          selectedFeature.levelname = res.data.data.levelname;
          selectedFeature.statetime = res.data.data.statetime;

          selectedFeature.desc = res.data.data.desc;
          selectedFeature.lswm = res.data.data.info_a;
          selectedFeature.ccfa = res.data.data.info_b;

          let lswmFileList = [];
          let ccfaFileList = [];
          let jjFileList = [];
          let booklistData = [];
          let booklist = res.data.data.booklist
          if (booklist) {
            for (let key in booklist) {
              let group = booklist[key];
              booklistData.push(group)
              if (group.lswm == 2) {
                for (let j in group.filelist) {
                  lswmFileList.push(group.filelist[j]);
                }
              }
              if (group.ccfa == 2) {
                for (let j in group.filelist) {
                  ccfaFileList.push(group.filelist[j]);
                }
              }
              if (group.jj == 2) {
                for (let j in group.filelist) {
                  jjFileList.push(group.filelist[j]);
                }
              }
            }
          }
          selectedFeature.booklistData = booklistData;
          selectedFeature.jjFileList = jjFileList;
          selectedFeature.lswmFileList = lswmFileList;
          selectedFeature.ccfaFileList = ccfaFileList;
          this.selectedFeature = selectedFeature;
          this.$store.commit("setSearchResultDialogType", 1);
          this.$refs.searchResultDialog.toggleShow(true);
        }
      });
    },
    // 获取地图文物详情
    getRelicDetail(selectedFeature) {
      // 获取文化点的图片
      let params = {
        sno: selectedFeature.resoure,
      };
      this.$axios({
        url: "/chinacul/home/aajax/getculturalrelic",
        method: "get",
        params: params,
      }).then((res) => {
        let { code } = res.data;

        if (code === 0) {
          selectedFeature.cover = res.data.data.cover;
          selectedFeature.imglist = res.data.data.imglist;

          selectedFeature.address = res.data.data.address;
          selectedFeature.longitude = res.data.data.longitude;
          selectedFeature.latitude = res.data.data.latitude;
          selectedFeature.altitude = res.data.data.altitude;
          selectedFeature.levelname = res.data.data.levelname;
          selectedFeature.statetime = res.data.data.statetime;
          selectedFeature.desc = res.data.data.desc;

          this.selectedFeature = selectedFeature;

          this.$store.commit("setSearchResultDialogType", 1);
          this.$refs.searchResultDialog.toggleShow(true);
        }
      });
    },
  },

  mounted() {
    this.init();
  },
};
</script>
 
<style scoped lang="less" >
.map-render {
  width: 100%;
  height: 100%;

  .map {
    width: 100%;
    height: 100%;
    background-color: #fff;
  }

  /deep/ .ol-tooltip {
    position: relative;
    background: rgba(3, 116, 13, 0.753);
    border-radius: 4px;
    color: #fff;
    padding: 4px 8px;
    opacity: 0.7;
    white-space: nowrap;
    font-size: 12px;
  }

  /deep/ .ol-tooltip-measure {
    opacity: 1;
    font-weight: bold;
  }

  /deep/ .ol-tooltip-static {
    background-color: #ffcc33;
    color: #034ae8;
    border: 1px solid white;
    text-shadow: #fff 1px 1px 2px;
  }

  /deep/ .ol-tooltip-measure:before,
  /deep/ .ol-tooltip-static:before {
    border-top: 6px solid rgba(0, 0, 0, 0.5);
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
    content: "";
    position: absolute;
    bottom: -6px;
    margin-left: -7px;
    left: 50%;
  }

  /deep/ .ol-tooltip-static:before {
    border-top-color: #ffcc33;
  }
}

// .coor {
//   position: absolute;
//   right: 140px;
//   bottom: 85px;
//   color: #fff;
//   z-index: 9999;
// }
.left-nav {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0;
  width: 45px;
  background-color: #264c9d;
  padding-top: 10px;

  .nav-item {
    height: 40px;
    text-align: center;
    font-size: 20px;
    color: #fff;

    span {
      margin-top: 10px;
    }

    span:hover {
      cursor: pointer;
      color: rgb(165, 163, 163);
    }
  }

  .nav-item.active {
    background-color: #097c25;
  }
}
</style>

 
